export default __webpack_public_path__ + "static/media/5.4b9d00a7.jpeg";